import { render, staticRenderFns } from "./ImgFile.vue?vue&type=template&id=ef61e374&scoped=true&lang=html"
import script from "./ImgFile.vue?vue&type=script&lang=js"
export * from "./ImgFile.vue?vue&type=script&lang=js"
import style0 from "./ImgFile.vue?vue&type=style&index=0&id=ef61e374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef61e374",
  null
  
)

export default component.exports